<svg width="12" height="12" viewBox="0 0 20 11" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10 11L0.473721 0.5L19.5263 0.5L10 11Z" fill="white"/>
</svg>
